import { z } from 'zod';

/* ─────────── Общий журнал работ из принятых отчётов площадки (ДК-07, раздел 6.15) ─────────── */

export const WorkJournalQuery = z.strictObject({
  projectId: z.uuid(),
  objectId: z.uuid().optional(),
  from: z.iso.date().optional(),
  to: z.iso.date().optional(),
});
export type WorkJournalQuery = z.infer<typeof WorkJournalQuery>;

/** Одна запись журнала — одна работа из принятого отчёта смены. Суммы денег в журнал не попадают. */
export interface WorkJournalEntry {
  /** Сквозной номер записи в выбранном периоде */
  no: number;
  reportId: string;
  lineId: string;
  day: string;
  shift: string;
  objectId: string | null;
  objectName: string | null;
  activityId: string;
  activityName: string;
  packageName: string;
  unit: string;
  /** Принятый объём (строкой, без потери точности) */
  quantity: string;
  /** Что заявлено на площадке, если принято иное */
  claimed: string;
  people: number;
  machines: number;
  photos: number;
  authorName: string;
  note: string | null;
}

export interface WorkJournal {
  projectId: string;
  projectCode: string;
  projectName: string;
  from: string;
  to: string;
  entries: WorkJournalEntry[];
  /** Принятые отчёты, попавшие в журнал */
  reportsCount: number;
  /** Отчёты за период, которые ещё не приняты и потому в журнал не вошли */
  pendingReports: number;
  /** Дни периода, в которых нет ни одного принятого отчёта (только рабочие дни по графику не считаются — просто дни) */
  daysWithoutEntries: number;
}
